import type { AxiosError } from 'axios';
import type { SWRResponse } from 'swr';
import useSWR from 'swr';
import type {
  GetFeetCharacteristicsRequest,
  GetFeetCharacteristicsResponse,
} from '~/api/aspida/@types';
import { getFeetCharacteristics } from '~/api/feetCharacteristics';

// child_id 未確定時は fetch をスキップする
type UseGetFeetCharacteristicsArgs = Omit<GetFeetCharacteristicsRequest, 'child_id'> & {
  child_id: GetFeetCharacteristicsRequest['child_id'] | undefined;
};

export const useGetFeetCharacteristics = (
  args: UseGetFeetCharacteristicsArgs,
): SWRResponse<GetFeetCharacteristicsResponse, AxiosError> => {
  const canFetch = args.child_id !== undefined;
  return useSWR(canFetch ? ['getFeetCharacteristics', args] : null, ([_]) =>
    getFeetCharacteristics(args as GetFeetCharacteristicsRequest),
  );
};
